import { ChangeEvent, ReactElement, useRef, RefObject } from "react";
import { Label, RadioButton } from "@justworkshr/milo-form";
import styles from "./access-option.module.css";

const AccessOption = ({
  id,
  label,
  value,
  description,
  onChange,
}: {
  id: string;
  label: string;
  description?: string;
  value: string;
  onChange?: (s: string, e: ChangeEvent<HTMLInputElement>) => void;
}): ReactElement => {
  const radioRef: RefObject<HTMLInputElement> = useRef(null);

  return (
    <Label htmlFor={id}>
      <div
        className={`${styles.accessOptionButton} ${
          radioRef.current?.checked ? styles.selectedOption : ""
        }`}
      >
        <div>
          <RadioButton
            ref={radioRef}
            value={value}
            label={""}
            id={id}
            onChange={onChange}
            name="accessOption"
          />
        </div>
        <div className={styles.radioText}>
          {label}
          <p className={styles.description}>{description}</p>
        </div>
      </div>
    </Label>
  );
};

export default AccessOption;
